// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3DAm1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__11RGa"};